import { render } from "./Affiliates.vue?vue&type=template&id=ff6ff2ce"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"

import "./Affiliates.vue?vue&type=style&index=0&id=ff6ff2ce&lang=css"
script.render = render

export default script